import {message} from '@sail/intl';

export const chooseCountryLanguage = message({
  id: 'mkt-ssr.globalization_picker.choose_country_language',
  defaultMessage: 'Choose country and language',
  description: 'Label for selecting country and language',
});

export const countryLanguageList = message({
  id: 'mkt-ssr.globalization_picker.country_language_list',
  defaultMessage: 'Country/language list',
  description: 'Title for the list of countries and languages',
});

export const availableLanguages = message({
  id: 'mkt-ssr.globalization_picker.available_languages',
  defaultMessage: 'Available languages',
  description: 'Label for the list of available languages',
});
